module.exports = __webpack_public_path__ + "static/img/dsh5-6.05a5421.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingDetail/dsh5-6.jpg
// module id = NjVY
// module chunks = 0